module.exports = __webpack_public_path__ + "media/images/front/pc/default/noimage_s120x120-fa62beb90f87bbc47ed6241373f5e4c8.png";